module.exports = __webpack_public_path__ + "img/charging-hub-suggestion.3d218aed.svg";